import { render, staticRenderFns } from "./PresetsSelectionForm.vue?vue&type=template&id=dd11d3d2&scoped=true"
import script from "./PresetsSelectionForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./PresetsSelectionForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PresetsSelectionForm.vue?vue&type=style&index=0&id=dd11d3d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd11d3d2",
  null
  
)

export default component.exports